export const defexCategories = [
  {
    type: 'Folhas',
    tags: [
      {
        value: "folha-amarela",
        label: "Folhas amareladas"
      },
      {
        value: "folha-verde-escura",
        label: "Folhas verde escura"
      },
      {
        value: "folha-verde-azulada",
        label: "Folhas verde azulada"
      },
      {
        value: "folha-morrom-amarelada",
        label: "Folhas morrom amarelada"
      },
      {
        value: "folha-marrom-ferrugem",
        label: "Folhas marrom ferrugem"
      },
      {
        value: "folha-verde-limao",
        label: "Folhas verde limão"
      },
      {
        value: "folha-roxa-cobre",
        label: "Folhas roxa cobre"
      },
      {
        value: "folha-roxa-metalica",
        label: "Folhas roxa metalica"
      },
      {
        value: "folha-sem-brilho",
        label: "Folha sem brilho"
      },
      {
        value: "folha-enrola",
        label: "Folhas enrolam"
      },
      {
        value: "folha-cai",
        label: "Folhas caem"
      },
      {
        value: "folha-menor",
        label: "Folhas menores"
      },
      {
        value: "folha-fraca",
        label: "Folhas fracas"
      },
      {
        value: "folhas-finas",
        label: "Folhas finas"
      },
      {
        value: "folha-queima",
        label: "Folhas queimadas"
      },
      {
        value: "folha-inferior-enrola",
        label: "Folhas inferiores enrolam"
      },
      {
        value: "folha-clorose",
        label: "Folhas clorose"
      },
      {
        value: "folha-enferrujada",
        label: "Folhas enferrujadas"
      },
      {
        value: "folha-murcha",
        label: "Folhas murcham"
      }
    ]
  },
  {
    type: 'Caule',
    tags: [
      {
        value: "caule-fraco",
        label: "Caule fraco"
      },
      {
        value: "caule-listra",
        label: "Caule com listras"
      },
      {
        value: "caule-lenhoso",
        label: "Caule lenhoso"
      }
    ]
  },
  {
    type: 'Gosto',
    tags: [
      {
        value: "gosto-verde",
        label: "Gosto verde (de mato)"
      },
      {
        value: "gosto-quimico",
        label: "Gosto químico"
      }
    ]
  },
  {
    type: 'Raízes',
    tags: [
      {
        value: "raiz-morre",
        label: "Raíz morre"
      },
      {
        value: "raiz-acida",
        label: "Raíz ácida"
      }

    ]
  },
  {
    type: 'Química',
    tags: [
      {
        value: "transporte-agua-fraco",
        label: "Transporte de água fraco"
      },
      {
        value: "absorcao-potassio-bloqueada",
        label: "Absorção de potássio bloqueada"
      },
      {
        value: "deficiencia-zinco",
        label: "Deficiência de zinco"
      },
      {
        value: "deficiencia-calcio",
        label: "Deficiência de cálcio"
      },
      {
        value: "toxicidade-salina",
        label: "Toxicidade salina"
      },
      {
        value: "clorose-internerval",
        label: "Clorose internerval"
      }
    ]
  },
  {
    type: 'Desenvolvimento',
    tags: [
      {
        value: "planta-fraca",
        label: "Planta fraca"
      },
      {
        value: "baixo-rendimento",
        label: "Baixo rendimento"
      },
      {
        value: "baixo-desenvolvimento",
        label: "Baixo desenvolvimento"
      },
      {
        value: "crescimento-diminui",
        label: "Crescimento diminuído"
      },
      {
        value: "desenvolvimento-lento",
        label: "Desenvolvimento lento"
      },
      {
        value: "maior-ramificacao",
        label: "Maior ramificação"
      }
    ]
  },
  {
    type: 'Outras',
    tags: [
      {
        value: "peciolo-roxo",
        label: "Peciolo roxo"
      },
      {
        value: "menor-espaco",
        label: "Menor espaço"
      },
      {
        value: "menor-espaco-intermodal",
        label: "Menor espaço intermodal"
      },
      {
        value: "aparencia-doentia",
        label: "Aparência doentia"
      }
    ]
  }
]

export const defexContents = [
  {
    classification: "NPK",
    slang: "pri",
    elements: [
      {
        element: "Nitrogênio",
        simbol: "N",
        image: "nitrogenio",
        deficiency: [
          {
            tag: ["folha-amarela"],
            message: "As folhas inferiores ficam amarelas"
          },
          {
            tag: ["folha-sem-brilho"],
            message: "As folhas perdem o brilho"
          },
          {
            tag: ["folha-amarela"],
            message: "O amarelamento progride para cima"
          },
          {
            tag: ["folha-amarela", "folha-enrola"],
            message: "As folhas continuam a amarelar, enrolar e descolorir"
          },
          {
            tag: ["folha-cai"],
            message: "As folhas começam a cair"
          },
          {
            tag: ["folha-menor"],
            message: "As plantas são mais curtas e com folhas menores"
          },
          {
            tag: ["baixo-rendimento"],
            message: "Floração prematura e baixo rendimento"
          }
        ],
        excess: [
          {
            tag: ["folha-verde-escura"],
            message: "As folhas inferiores ficam verde-escuras exuberantes"
          },
          {
            tag: ["folha-verde-escura"],
            message: "O verde sobe"
          },
          {
            tag: ["folha-fraca"],
            message: "A folhagem fica fraca"
          },
          {
            tag: ["caule-fraco"],
            message: "Os caules ficam fracos"
          },
          {
            tag: ["transporte-agua-fraco"],
            message: "O sistema de transporte de água/fluidos torna-se fraco"
          },
          {
            tag: ["gosto-verde"],
            message: "A colheita tem gosto verde"
          }
        ]
      },
      {
        element: "Fósforo",
        simbol: "P",
        image: "fosforo",
        deficiency: [
          {
            tag: ["folha-verde-azulada"],
            message: "As folhas ficam verde-azuladas"
          },
          {
            tag: ["peciolo-roxo"],
            message: "Os pecíolos ficam com uma cor arroxeada"
          },
          {
            tag: ["crescimento-diminui"],
            message: "O crescimento vertical e lateral diminui"
          },
          {
            tag: ["folha-roxa-cobre"],
            message: "Manchas mortas de cor cobre escura ou roxa a enegrecida nas folhas inferiores"
          },
          {
            tag: ["folha-roxa-metalica"],
            message: "Folhas gravemente afetadas desenvolvem folhas roxas metálicas bronzeadas escuras que continuam a enrolar, contorcer-se, murchar e cair"
          },
          {
            tag: ["planta-fraca"],
            message: "Planta fraca, suscetível a doenças e pragas"
          }
        ],
        excess: [
          {
            tag: ["deficiencia-zinco"],
            message: "Deficiências de micronutrientes de zinco e ferro"
          },
          {
            tag: ["clorose-internerval"],
            message: "Folhas mais novas desenvolvem clorose internerval"
          },
          {
            tag: ["folhas-finas"],
            message: "Folhas novas crescem em lâminas finas"
          },
          {
            tag: ["folha-queima"],
            message: "Pontas e margens das folhas queimam"
          },
          {
            tag: ["menor-espaco"],
            message: "Menos espaço intermodal"
          },
          {
            tag: ["baixo-rendimento"],
            message: "Colheita diminuída"
          },
          {
            tag: ["deficiencia-calcio"],
            message: "Aparecem deficiências de cálcio e magnésio"
          },
          {
            tag: ["folha-inferior-enrola"],
            message: "As folhas inferiores enrolam-se, desenvolvem manchas"
          },
          {
            tag: ["raiz-morre"],
            message: "As pontas das raízes morrem"
          },
          {
            tag: ["gosto-quimico"],
            message: "Os botões secos têm sabor químico"
          }
        ]
      },
      {
        element: "Potássio",
        simbol: "K",
        image: "potassio",
        deficiency: [
          {
            tag: ["folha-clorose"],
            message: "As folhas mais velhas ficam pálidas e sofrem clorose"
          },
          {
            tag: ["folha-enferrujada"],
            message: "As margens e pontas das folhas ficam enferrujadas e queimam"
          },
          {
            tag: ["caule-fraco"],
            message: "Os caules muitas vezes ficam fracos, magros e às vezes quebradiços"
          },
          {
            tag: ["maior-ramificacao"],
            message: "A ramificação do caule pode aumentar"
          },
          {
            tag: ["baixo-rendimento"],
            message: "Floração retardada e diminuída"
          }
        ],
        excess: [
          {
            tag: ["raiz-acida"],
            message: "A zona radicular é acidificada"
          },
          {
            tag: ["deficiencia-calcio"],
            message: "Causa deficiências de cálcio, magnésio, zinco e ferro"
          },
          {
            tag: ["folha-clorose"],
            message: "Folhas mais novas desenvolvem clorose internerval"
          },
          {
            tag: ["folha-finas"],
            message: "Folhas novas crescem em lâminas finas"
          },
          {
            tag: ["folha-queima"],
            message: "Pontas e margens das folhas queimam"
          },
          {
            tag: ["menor-espaco-intermodal"],
            message: "Menos espaço intermodal"
          },
          {
            tag: ["folha-enrola"],
            message: "As folhas inferiores enrolam-se, desenvolvem manchas"
          },
          {
            tag: ["raiz-morre"],
            message: "As pontas das raízes morrem"
          }
        ]
      }
    ]
  },
  {
    classification: "CaMgS",
    slang: "sec",
    elements: [
      {
        element: "Cálcio",
        simbol: "Ca",
        image: "calcio",
        deficiency: [
          {
            tag: ["folha-enrola"],
            message: "As folhas inferiores se contorcem e enrolam"
          },
          {
            tag: ["folha-morrom-amarelada"],
            message: "Manchas irregulares marrom-amareladas se desenvolvem nas folhas e margens"
          },
          {
            tag: ["desenvolvimento-lento"],
            message: "O desenvolvimento das flores é lento"
          },
          {
            tag: ["raiz-morre"],
            message: "As pontas das raízes podem morrer"
          },
          {
            tag: ["baixo-rendimento"],
            message: "Planta atrofiada, colheita diminuída"
          }
        ],
        excess: [
          {
            tag: ["folha-murcha"],
            message: "Pequena murcha das folhas"
          },
          {
            tag: ["baixo-desenvolvimento"],
            message: "O crescimento pode ser atrofiado"
          },
          {
            tag: ["absorcao-potassio-bloqueada"],
            message: "Absorção de potássio, ferro, magnésio e manganês bloqueada"
          }
        ]
      },
      {
        element: "Magnésio",
        simbol: "Mg",
        image: "magnesio",
        deficiency: [
          {
            tag: [],
            message: "As deficiências existem 4 - 6 semanas antes que os sinais externos sejam aparentes"
          },
          {
            tag: ["folha-marrom-ferrugem"],
            message: "Amarelelamento internerval e manchas marrom-ferrugem irregulares aparecem nas folhas mais velhas e de meia-idade"
          },
          {
            tag: ["aparencia-doentia"],
            message: "Aparência geral doentia"
          },
          {
            tag: ["folha-cai"],
            message: "As folhas mais velhas secam, muitas vezes enrolam e caem"
          }
        ],
        excess: [
          {
            tag: ["baixo-desenvolvimento"],
            message: "Crescimento atrofiado"
          },
          {
            tag: ["folha-verde-escura"],
            message: "Folhagem verde escura"
          },
          {
            tag: ["toxicidade-salina"],
            message: "Os sintomas aparecem como toxicidade salina geral"
          }
        ]
      },
      {
        element: "Enxofre",
        simbol: "S",
        image: "enxofre",
        deficiency: [
          {
            tag: ["folha-verde-limao"],
            message: "As folhas novas tornam-se verde-limão a amareladas e o crescimento é atrofiado"
          },
          {
            tag: ["folha-amarela"],
            message: "À medida que a escassez avança, as nervuras das folhas ficam amareladas e perdem suculência"
          },
          {
            tag: ["folha-queima"],
            message: "As pontas das folhas podem queimar, escurecer e ficar presas para baixo"
          },
          {
            tag: ["caule-listra"],
            message: "Longas listras roxas podem aparecer no comprimento do caule quando combinadas com uma deficiência geral de nutrientes"
          },
          {
            tag: ["caule-lenhoso"],
            message: "Os caules muitas vezes ficam lenhosos"
          },
          {
            tag: ["desenvolvimento-lento"],
            message: "A formação de botões é lenta e fraca"
          }
        ],
        excess: [
          {
            tag: ["folha-verde-escura"],
            message: "Desenvolvimento geral da planta menor e folhagem verde-escura uniformemente menor"
          },
          {
            tag: ["folha-queima"],
            message: "As pontas e margens das folhas podem descolorir e queimar quando o excesso é severo"
          }
        ]
      }
    ]
  },
  {
    classification: "Micronutrientes",
    slang: "mic",
    elements: [
      {
        element: "Boro",
        simbol: "B",
        image: "boro",
        deficiency: [
          {
            tag: ['folha-enrola'],
            message: "As folhas inferiores se contorcem e enrolam"
          }
        ],
        excess: [
          {
            tag: ['folha-murcha'],
            message: "Pequena murcha das folhas"
          }
        ]
      },
      {
        element: "Manganes",
        simbol: "Mn",
        image: "manganes",
        deficiency: [
          {
            tag: [],
            message: "As deficiências existem 4 - 6 semanas antes que os sinais externos sejam aparentes"
          }
        ],
        excess: [
          {
            tag: ['crescimento-diminui'],
            message: "Crescimento atrofiado"
          }
        ]
      },
      {
        element: "Zinco",
        simbol: "Zn",
        image: "zinco",
        deficiency: [
          {
            tag: ['folha-verde-limao'],
            message: "As folhas novas tornam-se verde-limão a amareladas e o crescimento é atrofiado"
          }
        ],
        excess: [
          {
            tag: ['folha-verde-escura'],
            message: "Desenvolvimento geral da planta menor e folhagem verde-escura uniformemente menor"
          }
        ]
      },


      {
        element: "Cloro",
        simbol: "Cl",
        image: "cloro",
        deficiency: [
          {
            tag: ['folha-verde-limao'],
            message: "As folhas novas tornam-se verde-limão a amareladas e o crescimento é atrofiado"
          }
        ],
        excess: [
          {
            tag: ['folha-verde-escura'],
            message: "Desenvolvimento geral da planta menor e folhagem verde-escura uniformemente menor"
          }
        ]
      },
      {
        element: "Molibdênio",
        simbol: "Mb",
        image: "molibdenio",
        deficiency: [
          {
            tag: ['folha-verde-limao'],
            message: "As folhas novas tornam-se verde-limão a amareladas e o crescimento é atrofiado"
          }
        ],
        excess: [
          {
            tag: ['folha-verde-escura'],
            message: "Desenvolvimento geral da planta menor e folhagem verde-escura uniformemente menor"
          }
        ]
      },
      {
        element: "Cobre",
        simbol: "Cu",
        image: "cobre",
        deficiency: [
          {
            tag: ['folha-verde-limao'],
            message: "As folhas novas tornam-se verde-limão a amareladas e o crescimento é atrofiado"
          }
        ],
        excess: [
          {
            tag: ['folha-verde-escura'],
            message: "Desenvolvimento geral da planta menor e folhagem verde-escura uniformemente menor"
          }
        ]
      },
      {
        element: "Ferro",
        simbol: "Fe",
        image: "ferro",
        deficiency: [
          {
            tag: ['folha-verde-limao'],
            message: "As folhas novas tornam-se verde-limão a amareladas e o crescimento é atrofiado"
          }
        ],
        excess: [
          {
            tag: ['folha-verde-escura'],
            message: "Desenvolvimento geral da planta menor e folhagem verde-escura uniformemente menor"
          }
        ]
      }
    ]
  }
]